import { render, staticRenderFns } from "./index.vue?vue&type=template&id=133977dc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133977dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('133977dc')) {
      api.createRecord('133977dc', component.options)
    } else {
      api.reload('133977dc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=133977dc&scoped=true", function () {
      api.rerender('133977dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/correspondence/reply/index.vue"
export default component.exports